import isEmpty from 'lodash/isEmpty';
import * as common from '../apiCommon';
import { LIST } from '../../constants/constant_doc_types';

export const fetchListDropdown = (app, params) => {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'list/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
};

export const fetchListById = (app, params) => {
  const { id } = params;
  const docType = LIST;

  return common.getDoc(app, { id, docType });
};

export const saveList = (app, dataToSave) => {
  const { user = {}, data } = dataToSave;

  data.items = (data.items || []).filter(item => item.text && item.value);

  const listData = {
    active: data.active,
    short_name: data.short_name,
    doc_type: LIST,
    name: data.name,
    items: isEmpty(data.items)
      ? undefined
      : data.items.map(({ text, value }) => ({
          text,
          value,
        })),
  };

  return common.saveDoc(app, {
    source: data,
    doc: listData,
    user,
  });
};

export const deleteList = (app, data) => {
  return common.deleteDoc(app, {
    id: data.id,
    docType: LIST,
  });
};
